import firebase from "firebase/compat/app";
import { useEffect, useState } from "react";
import toast from "react-hot-toast";
import { useDispatch, useSelector } from "react-redux";
import { saveData, uploadImage } from "../../../firebase/utility";
import { DEFAULT_PERMISSIONS, syncPermissions } from "../../../utils/permissions";
import { setUser } from "../../../store/actions/actions";

const useProfileHook = () => {
    const dispatch = useDispatch();
    const { user } = useSelector((state) => state.auth);
    const [loader, setLoader] = useState(false);
    const [userData, setUserData] = useState({
        username: "",
        email: "",
        address: "",
        phone: "",
        profileImage: "",
    });
    const [permissions, setPermissions] = useState([...DEFAULT_PERMISSIONS]);

    const handlePermissionChange = (e, index) => {
        let arr = [...permissions];

        arr[index].value = e.target.checked;
        setPermissions(arr);
    };

    const handleImageUpload = (type, file) => {
        if (type === "image") {
            setUserData({
                ...userData,
                profileImage: file,
            });
        }
    };
    const validateUser = () => {
        const { username, email, address, phone } = userData;
        if (!username || !email || !address || !phone) {
            toast.error("Please fill in all fields.");
            return false;
        }

        return true;
    };

    const handleUserUpdate = async () => {
        if (validateUser()) {
            let _id = user?._id;
            let uploadedImage;
            if (typeof userData?.profileImage === "object") {
                uploadedImage = await uploadImage(
                    userData?.profileImage,
                    "profile-images"
                );
            } else {
                uploadedImage = userData?.profileImage;
            }

            let obj = {
                ...user,
                ...userData,
                profileImage: uploadedImage,
                _id,
            };
            if (user?.permissions) {
                obj.permissions = user.permissions;
            }

            try {
                saveData("Users", _id, obj).then((res) => {
                    if (res) {
                        dispatch(setUser(obj));
                        toast.success("Profile Settings Updated Successfully");
                    }
                });
            } catch (error) {
                toast.error(error?.message);
            }
        }
    };
    useEffect(() => {
        setUserData({
            username: user?.username ?? "",
            email: user?.email ?? "",
            address: user?.address ?? "",
            phone: user?.phone ?? "",
            profileImage: user?.profileImage ?? "",
        });

        setPermissions(
            user?.permissions?.length > 0 ? syncPermissions(user.permissions) : [...DEFAULT_PERMISSIONS]
        );
    }, [user]);
    useEffect(() => {
        const unsubscribe = firebase
            .firestore()
            .collection("Users")
            .doc(user?._id)
            .onSnapshot((doc) => {
                if (doc.exists) {
                    const currentOrderData = doc.data();
                    setUserData({
                        username: currentOrderData?.username ?? "",
                        email: currentOrderData?.email ?? "",
                        address: currentOrderData?.address ?? "",
                        phone: currentOrderData?.phone ?? "",
                        profileImage: currentOrderData?.profileImage ?? "",
                    });
                }
            });
        return () => unsubscribe();
    }, []);

    return {
        handleUserUpdate,
        userData,
        setUserData,
        handleImageUpload,
        permissions,
        handlePermissionChange,
        user
    };
};

export default useProfileHook;
